import * as yup from "yup";
import { GetErrorObject } from "../Utils";

export const SiteSchema = yup.object().shape({
  Site: yup
    .string()
    .transform((value) => value || "")
    .required("Site Name is required."),
});

export function ValidateSite(input) {
  return new Promise(async function (resolve, reject) {
    try {
      SiteSchema.validate(input, { abortEarly: false })
        .then(function () {
          const data = {
            Site: {
              ...input,
            },
          };
          resolve({ data });
        })
        .catch(function (err) {
          const errors = GetErrorObject(err);
          resolve({ errors });
        });
    } catch (e) {
      reject(e);
    }
  });
}
